module.exports = __webpack_public_path__ + "static/media/gcdef_116.53235c72.ico";